<template>
  <NodeEvent v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
definePageMeta({
  path: '/event/:nid/:slug(.*)*',
  languageMapping: {
    fr: '/evenement/:nid/:slug(.*)*',
    it: '/evento/:nid/:slug(.*)*',
  },
  drupalRoute: true,
})

const { entity: node } = await useDrupalRouteQuery('nodeEvent')

useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>

<script lang="ts">
export default {
  name: 'PageEventSlug',
}
</script>
